import { dpi } from './constants.js';

/**
 * Converts inches to pixels.
 * @param {number} inch
 * @param {number} customDPI
 * @returns {number}
 */
const convertInchToPx = (inch, customDPI) => {
  return inch * (customDPI ?? dpi);
};

export default convertInchToPx;
